module.exports = __webpack_public_path__ + "static/media/pdc-avatar.cb10b76e.svg";